import React, { memo } from 'react';

import { Box } from '@mui/material';
import SearchInputCDS from '@sharedCR/coreDesignSystem/SearchInputCDS';
import PropTypes from 'prop-types';

import PendingChangesAuthorFilter from '../PendingChangesAuthorFilter';

import { SEARCH_MIN_QUERY_LENGTH, SEARCH_PLACEHOLDER } from './PendingChangesFilterBar.constants';
import {
  authorFilterWrapperStyles,
  filterBarStyles,
  searchWrapperStyles,
} from './PendingChangesFilterBar.styles';

const PendingChangesFilterBar = ({
  authors,
  authorColorMap,
  selectedAuthorKeys,
  isAuthorFilterDisabled = false,
  onAuthorToggle,
  onSearch,
}) => (
  <Box sx={filterBarStyles}>
    <Box sx={searchWrapperStyles}>
      <SearchInputCDS
        ariaLabel="Search pending changes"
        placeholder={SEARCH_PLACEHOLDER}
        validQueryLength={SEARCH_MIN_QUERY_LENGTH}
        onSearch={onSearch}
      />
    </Box>
    <Box sx={authorFilterWrapperStyles}>
      <PendingChangesAuthorFilter
        authorColorMap={authorColorMap}
        authors={authors}
        isDisabled={isAuthorFilterDisabled}
        selectedAuthorKeys={selectedAuthorKeys}
        onAuthorToggle={onAuthorToggle}
      />
    </Box>
  </Box>
);

PendingChangesFilterBar.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      formattedFullName: PropTypes.string,
    }),
  ).isRequired,
  authorColorMap: PropTypes.object.isRequired,
  selectedAuthorKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAuthorToggle: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  isAuthorFilterDisabled: PropTypes.bool,
};

export default memo(PendingChangesFilterBar);
